import React, { useCallback, useEffect, useState } from "react";

import {
	Button,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Paper,
	TextField,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { DeleteOutline, VisibilityOff, Visibility } from "@material-ui/icons";
import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const CloseReasonsManager = ({ className }) => {
	const [reasons, setReasons] = useState([]);
	const [name, setName] = useState("");

	const load = useCallback(async () => {
		try {
			const { data } = await api.get("/close-reasons", { params: { all: "true" } });
			setReasons(data.reasons || []);
		} catch (err) {
			toastError(err);
		}
	}, []);

	useEffect(() => {
		void load();
	}, [load]);

	const add = async () => {
		if (!name.trim()) return;
		try {
			await api.post("/close-reasons", { name });
			setName("");
			await load();
		} catch (err) {
			toastError(err);
		}
	};

	const toggle = async reason => {
		try {
			await api.put(`/close-reasons/${reason.id}`, { active: !reason.active });
			await load();
		} catch (err) {
			toastError(err);
		}
	};

	const remove = async reason => {
		try {
			await api.delete(`/close-reasons/${reason.id}`);
			toast.success(i18n.t("settings.success"));
			await load();
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<Paper className={className} style={{ display: "block" }}>
			<Typography variant="body1">{i18n.t("quality.reasonsTitle")}</Typography>
			<List dense>
				{reasons.map(r => (
					<ListItem key={r.id} disableGutters>
						<ListItemText
							primary={r.name}
							secondary={r.active ? null : i18n.t("quality.reasonInactive")}
						/>
						<ListItemSecondaryAction>
							<Tooltip title={r.active ? i18n.t("quality.reasonHide") : i18n.t("quality.reasonShow")}>
								<IconButton size="small" onClick={() => toggle(r)}>
									{r.active ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
								</IconButton>
							</Tooltip>
							<Tooltip title={i18n.t("quality.reasonDelete")}>
								<IconButton size="small" onClick={() => remove(r)}>
									<DeleteOutline fontSize="small" />
								</IconButton>
							</Tooltip>
						</ListItemSecondaryAction>
					</ListItem>
				))}
			</List>
			<div style={{ display: "flex", gap: 8 }}>
				<TextField
					fullWidth
					variant="outlined"
					margin="dense"
					label={i18n.t("quality.reasonName")}
					value={name}
					onChange={e => setName(e.target.value)}
					onKeyDown={e => e.key === "Enter" && add()}
					inputProps={{ maxLength: 80 }}
				/>
				<Button color="primary" variant="contained" onClick={add} disabled={!name.trim()} style={{ marginTop: 8, height: 40 }}>
					{i18n.t("quality.reasonAdd")}
				</Button>
			</div>
		</Paper>
	);
};

export default CloseReasonsManager;
